import * as angular from 'angular';
import * as moment from 'moment';
import { getByField, makeObjects } from "../../../common/common-functions";
import { Grid } from "ag-grid-community";
import 'ag-grid-enterprise';
import {v4 as uuidv4} from 'uuid';

//multiple activities grid
const modal_activities_grid = ['$scope', '$uibModal', '$uibModalInstance', 'GridService', '$timeout', '$rootScope', 'DatasetService', 'mapping',

    function ($scope, $uibModal, $uibModalInstance, GridService, $timeout, $rootScope, DatasetService, mapping) {

        $uibModalInstance.rendered.then(function () {
            console.log("Rendered, so now we will activate.");
            $scope.activateGrid();
        });

        $scope.system = {
            loading: true,
            messages: ["Processing data and preparing the grid. Please wait..."]
        };

        $scope.ActivityDuplicates = [];
        $scope.Activities = [];
        $scope.PageErrorCount = 0;
        $scope.DuplicateErrorCount = null;
        $scope.FieldErrorCount = 0;
        $scope.CheckingDuplicates = null;
        $scope.SavingActivities = null;
        $scope.ActivitiesPayload = [];
        $scope.ErroneousActivities = [];
        $scope.ErrorDuringDupCheck = {dupCheckError: false, rowCount: 0};
        // progress bar variables
        $scope.totalChunks = 0;
        $scope.completedChunks = 0;
        $scope.progressPercentage = 0;
        $scope.completedActivities = 0;
        $scope.missingKeyFields = {};
        $scope.totalAbortedRows = 0;
        $scope.TotalMissingKeyValues = 0;

        $scope.calculateStatistics = function () {
            if (!$scope.dataAgGridOptions.hasOwnProperty('api'))
                return; //not loaded yet.

            $scope.Activities = [];
            $scope.dataAgGridOptions.api.forEachNode(function (node) {
                // field errors: error.field !== null , duplicate errors: error.field === null
                if (node.data.rowHasError) {
                    const fieldErrors = node.data.validationErrors.filter(error => error.field !== null);
                    $scope.FieldErrorCount += fieldErrors.length;
                    $scope.PageErrorCount++;
                }
                // Calculate Activities
                calculateActivities(node);
            });
        };

        $scope.changeFilterIcons = function (event) {
            // We need to call this onFilterModified and onBodyScroll, as the elements are removed/added
            // to the DOM when scrolling horizontally on wide datasets.
            // Can also pass $scope.dataAgGridOptions to this function rather than an event.
            if (!$scope.dataAgGridOptions.api) return; // Allow to change the icon color only when the grid is ready
            let filters = $scope.dataAgGridOptions.api.getFilterModel();

            for (let col of event.api.columnController.columnDefs) {
                for (const span of document.querySelectorAll("span")) {
                    if (span.textContent.includes(col.field) || span.textContent.includes(col.headerName)) {
                        // Naming conventions vary, so lets check all of these to see if the column has a filter
                        if (col.Label in filters || col.headerName in filters || col.field in filters) {
                            // If column has a filter change the icon color
                            // @ts-ignore
                            let icon: HTMLElement = span.parentNode.parentNode.children[0].children[0];
                            console.log(icon);
                            icon.style.color = "#007bff";
                        }
                        else {
                            // Remove the color prop from the icon if there is no filter
                            // @ts-ignore
                            let icon: HTMLElement = span.parentNode.parentNode.children[0].children[0];// filterIcon.children[0];
                            if (icon && icon.style) {
                                icon.style.color = "#bdbdbd";
                            }
                        }
                    }
                }
            }
        };


        //ag-grid - header + details --- all in one grid for multiple activities
        $scope.dataAgGridOptions = {
            suppressPropertyNamesCheck: true,
            animateRows: true,
            //enableSorting: true,
            //enableFilter: true,
            //enableColResize: true,
            // showToolPanel: false,
            columnDefs: null,
            rowData: null,
            dataChanged: false, //updated to true if ever any data is changed
            rowSelection: 'multiple',
            onSelectionChanged: function (params) {

                const rows = params.api.getSelectedRows();
                $scope.dataAgGridOptions.selectedItems.length = 0; //truncate, don't replace with [] -- otherwise it is a shadow copy
                rows.forEach(function (row) {
                    $scope.dataAgGridOptions.selectedItems.push(row);
                });

                $scope.$apply(); //bump angular (won't work otherwise!)
            },
            onBodyScroll: function (event) {
                $scope.changeFilterIcons(event);
            },
            onFilterModified: function (event) {
                $scope.changeFilterIcons(event);
            },
            selectedItems: [],
            onGridReady: function (params) {
                console.log("GRID READY fired. ------------------------------------------>>>");
                $scope.system.loading = false;

                $scope.$apply();
                GridService.autosizeColumns($scope.dataAgGridOptions);

            },

            defaultColDef: {
                editable: true,
                sortable: true,
                resizable: true,
                icons: {
                    menu: "<span class='material-symbols-outlined' id='filter-icon' title='Filter'>filter_alt</span>", filter: "<span></span>",
                }
            },
            rowClassRules: {
                'row-validation-error': function (params) { return params.node.data.rowHasError; },
                'row-duplicate-error': function (params) {
                if (Array.isArray(params.node.data.validationErrors)) {
                    const rowDuplicateError = params.node.data.validationErrors.filter(error => error.field === null);
                    return rowDuplicateError.length > 0;
                }
                return false; // Default return value if validationErrors is not an array or empty
                }
            },
            // styling for the excel export. it works with style defined with cellClassRules and cellClass, not with rowClassRules
            excelStyles: [
                {
                    id: 'has-validation-error',
                    interior: {
                        color: '#ff8989', pattern: 'Solid'// background color
                    },
                },
                {
                    id: 'row-duplicate-error-for-excel',
                    font: {
                        bold: true
                    },
                },
                {
                    id: 'duplicate-error-fields',
                    font: {
                        underline: 'single'
                    },
                },
            ],

            onCellEditingStarted: function (event) {
                //console.log('cellEditingStarted');
                $scope.eventValueBeforeEdit = event.value;
            },
            onCellEditingStopped: function (event) {
                console.log("finished editing.");
                const validationUpdateObj = GridService.validateCellOnEdit(event, $scope);
                // update the row with the validation results
                $scope.PageErrorCount += validationUpdateObj.PageErrorCount;
                $scope.DuplicateErrorCount += validationUpdateObj.DuplicateErrorCount;
                $scope.FieldErrorCount += validationUpdateObj.FieldErrorCount;

                if (validationUpdateObj.FieldValidationErrors) {
                    GridService.fireRule("OnChange", event); //only fires when valid change is made
                }

                if ($scope.dataset.Config.EnableDuplicateChecking && $scope.dataset.Config.DuplicateCheckFields && $scope.dataset.Config.DuplicateCheckFields.contains(event.colDef.DbColumnName)) {
                    // update missing key fields object
                    updateMissingKeyFieldsObject(event, $scope.eventValueBeforeEdit);
                    // check for duplicates if enable duplicate checking is true
                    if ($scope.dataset.Config.EnableDuplicateChecking) {
                        $scope.checkRowForDuplicates(event.node);
                    }
                }
                // Recalculate activities after editing a cell to update the activity count
                $scope.Activities = [];
                $scope.dataAgGridOptions.api.forEachNode(function (node) {
                    calculateActivities(node);
                });
                event.api.redrawRows({ rowNodes: [event.node] });
            },
        };


        //call to fire up the grid after the $scope.dataset is ready
        $scope.activateGrid = function () {
            console.log("activating grid!");
            $scope.system.messages.push("Preparing data for grid...");
            //setup grid and coldefs and then go!

            $scope.dataAgColumnDefs = GridService.getAgColumnDefs($scope.dataset);

            //setup any possible values that are needed - detail
            $scope.dataAgColumnDefs.DetailFields.forEach(function (fieldDef) {
                if (fieldDef.field == "QAStatusId") { //RowQAStatusId because we're in the details
                    fieldDef.setPossibleValues(makeObjects($scope.dataset.RowQAStatuses, 'Id', 'Name'));
                }

                if (fieldDef.ControlType == 'file' || fieldDef.ControlType == 'hidden')
                    fieldDef.hide = true;
            });

            //setup activity fields to point to the right place
            $scope.dataAgColumnDefs.HeaderFields.forEach(function (fieldDef) {
                if (fieldDef.field == "LocationId") {
                    if (fieldDef.setPossibleValues) {
                        fieldDef.setPossibleValues(makeObjects($scope.project.Locations, 'Id', 'Label'));
                        fieldDef.field = "Activity." + fieldDef.DbColumnName;
                    }
                }

                if (fieldDef.field == "Description") {
                    fieldDef.field = "Activity." + fieldDef.DbColumnName;
                }

                if (fieldDef.field == "InstrumentId") {
                  fieldDef.field = "Activity." + fieldDef.DbColumnName;
                }

                if (fieldDef.field == "QAStatusId") { //ActivityQAStatusId
                    fieldDef.setPossibleValues(makeObjects($scope.dataset.QAStatuses, 'Id', 'Name'));
                    fieldDef.field = "Activity." + fieldDef.DbColumnName;
                }

                if (fieldDef.field == "QAComments") {
                    fieldDef.field = "Activity." + fieldDef.DbColumnName;
                }

                if (fieldDef.field == "ActivityDate") {
                    fieldDef.field = "Activity." + fieldDef.DbColumnName;
                }

                if (fieldDef.ControlType == 'file' || fieldDef.ControlType == 'hidden')
                    fieldDef.hide = true;

            });
            $scope.system.messages.push("Preparing grid...");

            $scope.dataAgGridOptions.columnDefs = $scope.dataAgColumnDefs.HeaderFields.concat($scope.dataAgColumnDefs.DetailFields);
            //$scope.fields = { header: $scope.dataAgColumnDefs.HeaderFields, detail: $scope.dataAgColumnDefs.DetailFields };

            console.log("Ready to go!");
            //console.dir($scope.dataAgGridOptions.columnDefs);
            //console.dir($scope.imported_rows);


            const ag_grid_div = document.querySelector('#data-import-grid') as HTMLElement;    //get the container id...
            $scope.ag_grid = new Grid(ag_grid_div, $scope.dataAgGridOptions); //bind the grid to it.
            //$scope.dataAgGridOptions.api.showLoadingOverlay(); //show loading...

            //set the detail values into the grid
            console.log("setting grid data");
            $scope.dataAgGridOptions.api.setRowData($scope.imported_rows);

            //console.log("GRID Validate. ------------------------------------------>>>");
            GridService.validateGrid($scope.dataAgGridOptions, $scope);
            //console.log("GRID Validate IS DONE ------------------------------------------>>>");

            //fire any onchange rules (like watertemp C to F)
            GridService.fireAllOnChange($scope.dataAgGridOptions);

            // add duplicate check key to each node (It is needed to accurately save erroneous activities even when checking for duplicates is disabled)
            addDuplicateCheckKeyToNode();

            if (!$scope.dataset.Config.EnableDuplicateChecking) {

              if ((confirm("Warning: This dataset is not configured to check for duplicates." +
                "\nIt is strongly recommended to contact your administrator to enable duplicate checking." +
                "\nOtherwise, you may proceed at your own risk."))) {
                    $scope.system.messages = [];
                } else {
                    $scope.system.messages = [];
                    $scope.cancel();
                    return;
                }
            }
            else {
              $scope.system.messages.push("Checking for duplicates...");
              console.log("GRID Dupe check ------------------------------------------>>>");
              $scope.checkAllRowsForDuplicates();
            }

            $scope.system.messages.push("Calculating statistics...");
            $scope.calculateStatistics();
            $scope.dataAgGridOptions.api.redrawRows();
            GridService.bubbleErrors($scope.dataAgGridOptions);
            $scope.system.messages.push("Done...");
        };

        //check for duplicates in all rows
        $scope.checkAllRowsForDuplicates = function () {
            // verify that all duplicate check fields are mapped to the grid columns
            const unMappedDuplicateCheckFields = getUnMappedDuplicateCheckFields();
            if (unMappedDuplicateCheckFields.length > 0) {
                const message = getUnMappedDuplicateCheckFieldsErrorMessage(unMappedDuplicateCheckFields);
                alert(`The following duplicate check fields are not mapped to the grid columns: \n${message}\n`+
                    'Please map them to check for duplicates.');
                $scope.system.messages = [];
                $scope.cancel();
                return;
            }

            $scope.CheckingDuplicates = true;
            const rows = [];
            $scope.missingKeyFields = {};
            $scope.totalAbortedRows = 0;
            //check for duplicate using each unique ActivityDate (if there is one defined (water temp doesn't have one))
            $scope.dataAgGridOptions.api.forEachNode(function (node) {
                let abortNoFullKeyForThisRow = false;
                const missingKeyFieldsForThisRow = {};
                const row = {
                    'Activity': {
                        'ActivityDate': node.data.Activity.ActivityDate,
                        'LocationId': node.data.Activity.LocationId,
                        'QAStatusId': node.data.Activity.QAStatusId,
                        'QAComments': node.data.Activity.QAComments,
                        'Id': 0,
                    },
                    'DuplicateCheckKey': node.data.duplicateCheckKey
                };

                // add other key fields and check if all key fields have values
                $scope.dataset.Config.DuplicateCheckFields.forEach(function (dc_field) {
                    if (!['ActivityDate', 'LocationId', 'QAStatusId', 'QAComments'].includes(dc_field))  {
                        row[dc_field] = node.data[dc_field];
                    }

                    if (!row[dc_field] && !row.Activity[dc_field]) { // field isn't set (row or activity)
                        if (!missingKeyFieldsForThisRow.hasOwnProperty(dc_field)){
                            // one missing, initialize it on missing key fields object
                            missingKeyFieldsForThisRow[dc_field] = 1;
                        } else {
                            missingKeyFieldsForThisRow[dc_field] += 1;
                        }
                        abortNoFullKeyForThisRow = true;
                    }
                });

                if (abortNoFullKeyForThisRow) {
                    $scope.totalAbortedRows += 1;
                    console.log("will abort duplicate checking on this row for empty field(s): " + $scope.getEmptyKeyFieldsErrorMessage(missingKeyFieldsForThisRow));
                    // add the missing key fields to the global missing key fields object
                    for (const [key, value] of Object.entries(missingKeyFieldsForThisRow)){
                        if (!$scope.missingKeyFields.hasOwnProperty(key)){
                            $scope.missingKeyFields[key] = value;
                        } else {
                            $scope.missingKeyFields[key] += value;
                        }
                    }
                    return;
                }

                rows.push(row);
            });

            if (Object.keys($scope.missingKeyFields).length > 0) { // if there are missing key fields
                const message = $scope.getEmptyKeyFieldsErrorMessage($scope.missingKeyFields);
                for (const value of Object.values($scope.missingKeyFields)){
                    $scope.TotalMissingKeyValues += value;
                }
                if (!confirm(`${$scope.totalAbortedRows} row(s) won't be checked for duplicate due to missing key values: \n${message}.\nDo you want to continue?`)) {
                    $scope.system.messages = [];
                    $scope.cancel();
                    return;
                }
            }

            $scope.processRowsInChunks(rows, 10);
            $scope.dataAgGridOptions.api.redrawRows();
            GridService.bubbleErrors($scope.dataAgGridOptions);
        };

        //checks a row(node) for duplicate record. if so, pushes to ActivityDuplicates
        $scope.checkRowForDuplicates = function (node) {
            let abortNoFullKeyForThisRow = false;
            const missingKeyFieldsForThisRow = {};
            const row = {
                'Activity': {
                    'ActivityDate': node.data.Activity.ActivityDate,
                    'LocationId': node.data.Activity.LocationId,
                    'QAStatusId': node.data.Activity.QAStatusId,
                    'QAComments': node.data.Activity.QAComments,
                    'Id': 0,
                }
            };

            // add other key fields and check if all key fields have values
            $scope.dataset.Config.DuplicateCheckFields.forEach(function (dc_field) {
                if (!['ActivityDate', 'LocationId', 'QAStatusId', 'QAComments'].includes(dc_field))  {
                    row[dc_field] = node.data[dc_field];
                }

                if (!row[dc_field] && !row.Activity[dc_field]) { // field isn't set (row or activity)
                    if (!missingKeyFieldsForThisRow.hasOwnProperty(dc_field)){
                        // one missing, initialize it on missing key fields object
                        missingKeyFieldsForThisRow[dc_field] = 1;
                    } else {
                        missingKeyFieldsForThisRow[dc_field] += 1;
                    }
                    abortNoFullKeyForThisRow = true;
                }
            });

            if (abortNoFullKeyForThisRow) {
                const message = $scope.getEmptyKeyFieldsErrorMessage(missingKeyFieldsForThisRow);
                console.log("will abort duplicate checking on this row for empty field(s): " + message);
                return;
            }

            // check for duplicate on the row
            // Note: the saveResult object is updated by the checkForDuplicates function of the GridService.
            //      it is used to get the error message and the hasError flag.
            //      resp.dupCheckError is the error returned from the backend while checking for duplicates.
            const saveResult = {error: "", hasError: false};
            const dupe_promise = GridService.checkForDuplicates($scope.dataset, $scope.dataAgGridOptions, row, saveResult);
            if (dupe_promise !== null) {
                dupe_promise.$promise.then(function (resp) {
                    // check if there are errors thrown while checking for duplicates
                    if (resp.dupCheckError) {
                        console.error("Error during duplicate check: " + resp.dupCheckError);
                        $scope.ErrorDuringDupCheck.dupCheckError = true;
                        $scope.ErrorDuringDupCheck.rowCount += 1;

                        alert('This row could not be verified for duplicates due to error(s) encountered during the duplicate check.')
                        return;
                    }
                    const rowDuplicateError = node.data.validationErrors.filter(error => error.field === null);
                    const initialRowHasError = node.data.rowHasError;
                    const activityDuplicate = $scope.getActivityNode(node);

                    activityDuplicate['Message'] = saveResult.error;
                    if (saveResult.hasError) { //is a duplicate!
                        if (rowDuplicateError.length === 0) { // if the duplicate error is not already in the row
                            $scope.ActivityDuplicates.push(activityDuplicate); //will be marked by a watcher
                            GridService.addErrorToNode(node, activityDuplicate.Message, null);
                            $scope.DuplicateErrorCount++;
                        }
                    }
                    else { // is not a duplicate!
                        if (rowDuplicateError.length > 0) { // if the duplicate error is in the row (the row was a duplicate but it is not anymore)
                            // remove the duplicate error from the row
                            $scope.DuplicateErrorCount--;
                            node.data.validationErrors.splice(node.data.validationErrors.indexOf(rowDuplicateError[0]), 1);
                            // update the row error tooltip
                            node.data.validationErrors.forEach(function (error, index) {
                                node.data.rowErrorTooltip = (index === 0) ? "" : node.data.rowErrorTooltip + "\n";
                                node.data.rowErrorTooltip = node.data.rowErrorTooltip +
                                ((error.field) ? "[" + error.field.DbColumnName + "] " + error.message : error.message);
                            });

                            $scope.ActivityDuplicates.splice($scope.ActivityDuplicates.indexOf(activityDuplicate), 1);
                            if (node.data.validationErrors.length === 0) { // if there are no more errors in the row
                                node.data.rowHasError = false;
                                node.data.rowErrorTooltip = "";
                            }
                        }
                    }
                    const finalRowHasError = node.data.rowHasError;
                    if (initialRowHasError !== finalRowHasError) {
                        $scope.PageErrorCount += (finalRowHasError) ? 1 : -1;
                    }
                }).finally(function () {
                    $scope.dataAgGridOptions.api.redrawRows({ rowNodes: [node] });
                });
            }
        };

        $scope.save = function () {
            $scope.system.messages.length = 0;
            $scope.system.loading = true;
            $scope.SavingActivities = true;
            $scope.completedActivities = 0;
            $scope.progressPercentage = 0;

            if (!confirm("A total of " + $scope.Activities.length + " activities will be saved.")) {
                $scope.system.loading = false;
                $scope.SavingActivities = null;
                return;
            }


            // Save activities in batches
            const batchSize = 10;
            processActivityBatch(0, batchSize);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss();
        };

        $scope.close = function () {
            $uibModalInstance.close();
        }

        $scope.processRowsInChunks = function (rows, chunkSize) {
            $scope.completedChunks = 0;
            $scope.totalChunks = Math.ceil(rows.length / chunkSize);
            $scope.progressPercentage = 0;

            function processChunkSequentially(chunkIndex) {
                if (chunkIndex >= $scope.totalChunks) {
                    $scope.CheckingDuplicates = false;
                    $scope.completedChunks = 0;
                    $scope.totalChunks = 0;
                    $scope.progressPercentage = 0;

                    // It is the end of dup checking for all rows, check if there are errors thrown while checking for duplicates
                    if ($scope.ErrorDuringDupCheck.dupCheckError) {
                      if (!confirm(`${$scope.ErrorDuringDupCheck.rowCount} row(s) could not be checked for duplicate due to error(s) encountered during the duplicate check.\nDo you want to continue?`)) {
                        $scope.system.messages = [];
                        $scope.cancel();
                        return;
                      }
                    }
                    return;
                }

                const chunk = rows.slice(chunkIndex * chunkSize, (chunkIndex + 1) * chunkSize);
                $scope.processChunk(chunk).finally(function () {
                    $scope.completedChunks++;
                    $scope.progressPercentage = Math.round(($scope.completedChunks / $scope.totalChunks) * 100);

                    // Process the next chunk after the current one finishes
                    processChunkSequentially(chunkIndex + 1);
                });
            }

            // Start processing the first chunk
            processChunkSequentially(0);
        };


        $scope.processChunk = function (chunk) {
            const dupe_promise = GridService.checkForAllDuplicates($scope.dataset, $scope.dataAgGridOptions, chunk);
            if (!dupe_promise) {
                return Promise.resolve(); // return a resolved promise if there is no promise to resolve
            }

            return dupe_promise.$promise.then(function (duplicateObj) {
                  // check if there are errors thrown while checking for duplicates
                  if (duplicateObj.dupCheckError) {
                    console.error("Error during duplicate check: " + duplicateObj.dupCheckError);
                    $scope.ErrorDuringDupCheck.dupCheckError = true;
                    $scope.ErrorDuringDupCheck.rowCount += chunk.length;
                }
                $scope.dataAgGridOptions.api.forEachNode(function (node) {
                    // if the row's duplicate check result is not in the duplicateObj, then skip the row
                    if (!duplicateObj[node.data.duplicateCheckKey]) {
                        return;
                    }
                    const rowDuplicateError = node.data.validationErrors.filter(error => error.field === null);
                    const duplicateActivityId = duplicateObj[node.data.duplicateCheckKey].DuplicateActivityId;
                    if (duplicateActivityId) { //is a duplicate!
                        if (rowDuplicateError.length === 0) { // if the duplicate error is not already in the row
                            if (!node.data.rowHasError) // if the row is not already marked as having an error
                                $scope.PageErrorCount++;
                            const activityDuplicate = $scope.getActivityNode(node);
                            const message = "Duplicate record exists for: " + $scope.dataset.Config.DuplicateCheckFields.toString().replace("Description", "DateRange").replace(/,/g, ", ") + ".";
                            activityDuplicate['Message'] = message;
                            $scope.ActivityDuplicates.push(activityDuplicate);
                            GridService.addErrorToNode(node, message, null);
                            $scope.DuplicateErrorCount++;
                        }
                    }
                    $scope.dataAgGridOptions.api.redrawRows({ rowNodes: [node] });
                });
            });
        }

        function processActivityBatch(batchIndex, batchSize) {
          const start = batchIndex * batchSize;
          const end = Math.min(start + batchSize, $scope.Activities.length);
          const batch = $scope.Activities.slice(start, end);

          const promises = batch.map(function (activity, index) {
              const keyValues = [];
              for (let key in activity) {
                  if (activity.hasOwnProperty(key)) {
                      keyValues.push(activity[key]);
                  }
              }
              const activityKey = keyValues.join('_');

              const payload = {
                  'Activity': null,
                  'DatasetId': $scope.dataset.Id,
                  'ProjectId': $scope.project.Id,
                  'UserId': $rootScope.Profile.Id,
                  'deletedRowIds': [],
                  'editedRowIds': [],
                  'header': null,
                  'details': [],
                  'ActivityKey': activityKey,
                  'ActivityRowKeys': [],
                  'ActivityWithDetailsRowKeys': [],
              };

              $scope.dataAgGridOptions.api.forEachNode(function (node) {
                  const activityNode = $scope.getActivityNode(node);

                  if (Object.keys(activityNode).every(key => activity[key] === activityNode[key])) {
                      payload.ActivityRowKeys.push(node.data.duplicateCheckKey);
                      if (payload.header == null) {
                          payload.Activity = node.data.Activity;
                          payload.header = {};

                          $scope.dataAgColumnDefs.HeaderFields.forEach(function (header_field) {
                              payload.header[header_field.DbColumnName] = node.data[header_field.DbColumnName];
                          });

                          payload.Activity.ActivityQAStatus = {
                              'Comments': node.data.Activity.QAComments,
                              'QAStatusId': node.data.Activity.QAStatusId,
                          };
                          delete payload.header['QAStatusId'];
                          delete payload.header['QAComments'];
                          delete payload.header['LocationId'];
                          delete payload.header['ActivityDate'];
                      }

                      if (node.data.data_row_hasdata) {
                          payload.ActivityWithDetailsRowKeys.push(node.data.duplicateCheckKey);
                          const the_detail = { 'QAStatusId': node.data['QAStatusId'] };

                          $scope.dataAgColumnDefs.DetailFields.forEach(function (detail_field) {
                              if (detail_field.ControlType == "multiselect" && Array.isArray(node.data[detail_field.DbColumnName]))
                                  the_detail[detail_field.DbColumnName] = angular.toJson(node.data[detail_field.DbColumnName]);
                              else
                                  the_detail[detail_field.DbColumnName] = node.data[detail_field.DbColumnName];
                          });
                          payload.details.push(the_detail);
                      } else {
                          console.log("Skipping data for this row because it was empty!");
                      }
                  }
              });

              $scope.ActivitiesPayload.push(payload);

              return DatasetService.saveActivities(payload).$promise.then(function (data) {
                  if (data.Status === "Error") {
                      $scope.ErroneousActivities.push({
                          'Status': 'Error',
                          'ActivityKey': data.ActivityKey,
                          'Message': data.Message,
                          'Rows': data.ActivityWithDetailsRowKeys
                      });
                  }
              });
          });

          // Wait for all the promises in the batch to complete
          Promise.all(promises).then(function () {
              $scope.completedActivities += batch.length;
              $scope.progressPercentage = Math.round(($scope.completedActivities / $scope.Activities.length) * 100);

              if (end < $scope.Activities.length) {
                  // Process the next batch
                  processActivityBatch(batchIndex + 1, batchSize);
              } else {
                  $scope.SavingActivities = false;
                  $scope.system.loading = false;
              }
          });
        }


        // Export rows to excel or csv file
        $scope.export = function (erroneousRows, exportType) {
            // store the initial column definitions to reset the grid after exporting rows
            const initialColumnDefs = $scope.dataAgGridOptions.columnDefs;
            // add a column definition for the error message
            const errorColumnDef = {
                headerName: 'Errors',
                field: 'rowErrorTooltip'
            }
            const erroneousColumnDefs = initialColumnDefs.concat(errorColumnDef);

            // set the column definitions to export the erroneous rows
            $scope.dataAgGridOptions.api.setColumnDefs(erroneousColumnDefs);

            // export parameters
            const exportParams = {
                fileName: getFileName(erroneousRows, exportType),
                processCellCallback: function (params) {
                    // in the exported file, Ids are displayed rather than the corresponding names for LocationId and QAStatusId
                    const mappingIdsToValues = params.column.colDef.PossibleValues;
                    if (params.column.colDef.DbColumnName === 'LocationId' || params.column.colDef.DbColumnName === 'QAStatusId') {
                        // Replace LocationId or QAStatusId with the corresponding name
                        if (mappingIdsToValues)
                            return mappingIdsToValues[params.value];
                    }

                    // Remove the new line characters from the error message
                    if (params.column.colDef.field === 'rowErrorTooltip') {
                        return params.value.replace(/\n/g, ' ');
                    }

                    return params.value;
                }
            };

            if (erroneousRows.length === 0) { // Before saving attempt, export all rows in the preview grid to an excel or csv file
                if (exportType === 'excel')
                    $scope.dataAgGridOptions.api.exportDataAsExcel(exportParams);
                else
                    $scope.dataAgGridOptions.api.exportDataAsCsv(exportParams);

                // reset the grid to the initial column definitions
                $scope.dataAgGridOptions.api.setColumnDefs(initialColumnDefs);

            } else {
                // store the initial row data to reset the grid after exporting the erroneous rows
                const initialRowData = [];
                $scope.dataAgGridOptions.api.forEachNode(function (node) {
                    initialRowData.push(node.data);
                });

                $scope.dataAgGridOptions.api.setRowData(erroneousRows);
                if (exportType === 'excel')
                    $scope.dataAgGridOptions.api.exportDataAsExcel(exportParams);
                else
                    $scope.dataAgGridOptions.api.exportDataAsCsv(exportParams);

                // reset the grid to the initial column definitions and row data
                $scope.dataAgGridOptions.api.setColumnDefs(initialColumnDefs);
                $scope.dataAgGridOptions.api.setRowData(initialRowData);
            }
        };

        // Get all rows of an activity if there is at least one erroneous row
        $scope.getErroneousActivitiesRows = function () {
            const erroneousRows = [];
            // This function is sometimes called before the grid is ready
            if ($scope.dataAgGridOptions.api === undefined) return erroneousRows;
            $scope.dataAgGridOptions.api.forEachNode(function (node) {
                if ($scope.ErroneousActivities.some(activity => activity.Rows.includes(node.data.duplicateCheckKey))) {
                    erroneousRows.push(node.data);
                }
            });
            return erroneousRows;
        }

        $scope.getTotalErroneousRows = function () {
            return $scope.ErroneousActivities.reduce((acc, activity) => acc + activity.Rows.length, 0);
        }

        $scope.getActivityNode = function (node) {
            const the_date = moment(node.data.Activity.ActivityDate)?.format('YYYY-MM-DDTHH:mm');
            const activityNode = {};
            $scope.dataset.Config.DuplicateCheckFields.forEach(function (dc_field) {
                if (['ActivityDate', 'LocationId', 'QAStatusId', 'QAComments'].includes(dc_field)) {
                    if (dc_field === 'ActivityDate')
                        activityNode[dc_field] = the_date;
                    else
                        activityNode[dc_field] = node.data.Activity[dc_field]?.toString();
                }
                else {
                    activityNode[dc_field] = node.data[dc_field]?.toString();
                }
            });
            return activityNode;
        }

        function calculateActivities(node) {
            try {
                const activityNode = $scope.getActivityNode(node);
                if (!$scope.Activities.some(activity => Object.keys(activity).every(key => activity[key] === activityNode[key]))) {
                    $scope.Activities.push(activityNode);
                }
            } catch (e) {
                console.warn("invalid date not added to Activities calculation: " + node.data.Activity.ActivityDate);
                console.dir(e);
            }
        }

        function getFileName(erroneousRows, exportType) {
            let fileNamePrefix = `${$scope.dataset.Datastore.TablePrefix}_${moment()?.format('YYYYMMDD_HHmmss')}`;
            if (erroneousRows.length === 0) {
                if (exportType === 'excel')
                    return `${fileNamePrefix}_rows.xlsx`;
                else
                    return `${fileNamePrefix}_rows.csv`;
            }
            else {
                if (exportType === 'excel')
                    return `${fileNamePrefix}_erroneous_activities.xlsx`;
                else
                    return `${fileNamePrefix}_erroneous_activities.csv`;
            }
        }

        $scope.getEmptyKeyFieldsErrorMessage =  function (missingKeyFields) {
            let errors = [];
            for (const [key, value] of Object.entries(missingKeyFields)){
                let fieldAlias = key;
                for (let col of Object.values($scope.dataAgColumnDefs)){
                    let fields = col as Array<any>;
                    for (let val of fields){
                        if (val.DbColumnName === key && val.Label){
                        fieldAlias = val.Label;
                        break
                        }
                    }
                }
                errors.push(`${fieldAlias} missing ${value} value(s)`)
            }

            return `${errors.join(', ')}`;
        }

        function updateMissingKeyFieldsObject(event, eventValueBeforeEdit) {
            if ((!eventValueBeforeEdit && event.value) || (eventValueBeforeEdit && !event.value)) {
                if ($scope.missingKeyFields.hasOwnProperty(event.colDef.DbColumnName)) {
                    if (!event.value) {
                        $scope.missingKeyFields[event.colDef.DbColumnName] += 1;
                        $scope.TotalMissingKeyValues += 1;
                    } else {
                        $scope.missingKeyFields[event.colDef.DbColumnName] -= 1;
                        $scope.TotalMissingKeyValues -= 1;
                    }
                    if ($scope.missingKeyFields[event.colDef.DbColumnName] === 0) {
                        delete $scope.missingKeyFields[event.colDef.DbColumnName];
                    }
                } else {
                    if (!event.value) {
                        $scope.missingKeyFields[event.colDef.DbColumnName] = 1;
                        $scope.TotalMissingKeyValues += 1;
                    }
                }
            }
        }

        function addDuplicateCheckKeyToNode() {
            $scope.dataAgGridOptions.api.forEachNode(function (node) {
                node.data.duplicateCheckKey = uuidv4();
            });
        }

        function getUnMappedDuplicateCheckFields() {
            const mapping = $scope.mapping;
            const unMappedColumnsLabel = [];
            let unMappedDuplicateCheckFields = [];
            for (const col of Object.keys(mapping)) {
                if (mapping[col].Label === '[-- Do not map --]') {
                    unMappedColumnsLabel.push(col);
                }
            }

            // mapping provides only labels, so we need to get the column names from the labels
            let unMappedColumnsFields = getUnMappedDuplicateCheckFieldsFromLabels(unMappedColumnsLabel);
            const duplicateCheckFields = $scope.dataset.Config.DuplicateCheckFields;
            unMappedDuplicateCheckFields = duplicateCheckFields.filter(field => unMappedColumnsFields.includes(field));
            return unMappedDuplicateCheckFields;
        }

        function getUnMappedDuplicateCheckFieldsErrorMessage(noneMappedDuplicateCheckFields) {
            let errors = [];
            noneMappedDuplicateCheckFields.forEach(value => {
                let fieldAlias = value;
                for (let col of Object.values($scope.dataAgColumnDefs)){
                    let fields = col as Array<any>;
                    for (let val of fields){
                        if (val.DbColumnName === value && val.Label){
                        fieldAlias = val.Label;
                        break
                        }
                    }
                }
                errors.push(`${fieldAlias}`)
            });

            return `${errors.join(', ')}.`;
        }

        function getUnMappedDuplicateCheckFieldsFromLabels(unMappedDuplicateCheckFieldsLabels) {
            let unMappedDuplicateCheckFields = [];
            unMappedDuplicateCheckFieldsLabels.forEach(value => {
                let fieldAlias = value;
                for (let col of Object.values($scope.dataAgColumnDefs)){
                    let fields = col as Array<any>;
                    for (let val of fields){
                        if (val.DbColumnName && val.Label === value){
                        fieldAlias = val.DbColumnName;
                        break
                        }
                    }
                }
                unMappedDuplicateCheckFields.push(`${fieldAlias}`)
            });
            return unMappedDuplicateCheckFields;
        }
    }
];

export default modal_activities_grid;
